export default __webpack_public_path__ + "static/media/Hostless-App_Deployment.a9a28cf1.jpg";